import React, { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import {
  TableAction,
  StatusFilter,
  SubmissionStatus,
  ArrayChecker,
  ControlledTable,
  SearchInput,
  Loader,
  // ActivityStatus,
  // RedDot
} from '../../../components'
import service from '../../../features/event/service'
import apiService from '../../../features/api/service'
import adapter from '../../../features/events/adapter'
import { SystemProvider } from '../../../features/system/provider'
import { ActivityStatus } from '../../../components/dashboard-listing/activity-status.override'
import { collectionAdapter } from '../../../features/collection/adapter'
import { useInternationalization } from '../../../features/i18n'

const LIMIT = 10
// const API_KEY = 'events'
const API_KEY = 'organization_events'
let lastStatusFilter = 'default'

const PageContent = () => {
  const [requesting, setRequesting] = React.useState(false)
  const { translate, language } = useInternationalization()
  const [selectedRows, setSelectedRows] = React.useState([])
  const [keyword, setKeyword] = React.useState('')
  const [selectedStatusFilter, setSelectedStatusFilter] = useState(null)

  // Controlled Table State
  const fetchIdRef = React.useRef(0)
  const [pageIndex, setPageIndex] = React.useState(0)
  const [pageCount, setPageCount] = React.useState(0)
  const [statusFilterData, setStatusFilterData] = useState([])

  const [tableData, setTableData] = React.useState()
  const tableColumns = useMemo(
    () => [
      {
        Header: translate('GENERAL', 'title'),
        accessor: 'title',
        // Cell: (props) => {
        //   const id = props.data[props.row.index].id
        //   return (
        //     <Link to={`/dashboard/events/update/${id}`}>
        //       {props.value}
        //     </Link>
        //   )
        // }
      },
      {
        Header: translate('GENERAL', 'city'),
        accessor: 'cities',
        Cell: (props) => {
          const text = props.data[props.row.index].city
          return (
            <>{props.value === 1 ? text : (
              <span title={text}>{props.value}</span>
            )}</>
          )
        }
      },
      {
        Header: translate('GENERAL', 'date'),
        accessor: 'date_short',
      },
      // {
      //   Header: 'Guests',
      //   accessor: 'guests',
      //   Cell: ({ value, row}) => (
      //     <div className="flex items-center">
      //       <div className="mr-1">{value ? value : '-'}</div>
      //       {row.original.unread && <div><RedDot /></div>}
      //     </div>
      //   )
      // },
      // {
      //   Header: 'Visibility',
      //   accessor: 'visibility',
      // },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => <ActivityStatus value={value}/>
      },
      // {
      //   Header: 'Event Status',
      //   accessor: 'status_id',
      //   Cell: ({ value }) => <ActivityStatus value={value}/>
      // },
      {
        Header: translate('GENERAL', 'submission'),
        accessor: 'submission',
        Cell: ({ value }) => <SubmissionStatus value={value}/>
      },
      {
        Header: '',
        accessor: 'id',
        Cell: (props) => {
          return (
            <div className="flex space-x-2">
              <Link to={generateLink('view', props.value)} target="_blank" className="text-sm underline text-gray-500">
                {translate('GENERAL', 'view')}
              </Link>
              <Link
                to={{
                  pathname: generateLink('edit', props.value),
                  state: {
                    title: 'Edit Event'
                  }
                }}
                className="text-sm underline text-gray-500"
              >
                Edit
              </Link>
            </div>
          )
        },
      }
    ],
    [translate]
  )

  const handleCheckbox = (rows) => setSelectedRows(rows)

  // Controlled table data fetcher
  const fetchData = React.useCallback(({ pageSize, pageIndex }) => {
    if(requesting === false){
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current

      // Set the loading state
      setRequesting(true)

      const startRow = pageSize * pageIndex
      const newQuery = {
        limit: pageSize,
        offset: startRow === 0 ? '0' : startRow
      }

      if(selectedStatusFilter !== 'all'){
        newQuery.submission = selectedStatusFilter
      }

      apiService.get(API_KEY, newQuery)
        .then(res => {
          // Only update the data if this is the latest fetch
          if (fetchId === fetchIdRef.current) {
            setTableData(matchDataToTable(adapter.responseBodyToRender(res.results), language))

            // Your server could send back total page count.
            // const totalData = serverData.length
            const totalData = res.count
            setPageCount(Math.ceil(totalData / pageSize))

            // Fetch initial status filter data. Once only, dont change.
            if(selectedStatusFilter === null){
              setStatusFilterData(collectionAdapter.responseBodyToByStatus(res.logSubmission))
            }
          }
        })
        .finally(() => {
          setRequesting(false)
        })
    }
  }, [language, requesting, selectedStatusFilter])

  const handleBulkAction = (form) => {
    if(form.action === 'delete' && selectedRows.length > 0){
      let c = window.confirm(translate('GENERAL', 'delete_confirm'))
      if(c){
        setRequesting(true)
        let count = 0

        const handleRequestDone = () => {
          count++
          if(count === selectedRows.length){
            setRequesting(false)

            // trigger re-fetch
            fetchData({pageSize: LIMIT, pageIndex: 0})
          }
        }

        for (let index = 0; index < selectedRows.length; index++) {
          const row = selectedRows[index];
          const id = row.original.id
          console.log('delete data with this id: ', id)

          service.delete(id)
          .then(res => console.log(res))
          .catch(err => console.log(err))
          .then(() => {
            console.log(id, ' deleted.')
            handleRequestDone()
          })
        }
      }
    }
  }

  const handlePageChange = React.useCallback(({ pageSize, pageIndex }) => {
    setPageIndex(pageIndex)
    fetchData({ pageSize, pageIndex })
  }, [fetchData])

  useEffect(() => {
    fetchData({pageSize: LIMIT, pageIndex: 0})
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if(selectedStatusFilter !== lastStatusFilter){
      lastStatusFilter = selectedStatusFilter
      fetchData({pageSize: LIMIT, pageIndex: 0})
    }
    // eslint-disable-next-line
  }, [selectedStatusFilter])

  const handleSearch = () => {
    console.log(keyword)
    if(requesting === false && typeof keyword === 'string'){
      setRequesting(true)

      apiService.get(API_KEY, {keyword})
        .then(res => {
          setTableData(matchDataToTable(adapter.responseBodyToRender(res.results), language))
          setPageCount(Math.ceil(res.count / LIMIT))
        })
        .finally(() => {
          setRequesting(false)
        })
    }
  }

  return <>
    <div style={{maxWidth: '370px'}} className="mb-5 lg:mb-8">
      <SearchInput onChange={(e) => setKeyword(e.target.value)} onSearchSubmit={handleSearch}/>
    </div>

    <div className="mb-5 lg:mb-8">
      <StatusFilter
        data={statusFilterData}
        selected={selectedStatusFilter}
        setSelected={setSelectedStatusFilter}
      />
    </div>

    { requesting &&
      <div className="flex justify-center mb-8">
        <Loader />
      </div>
    }

    <ArrayChecker data={tableData}>
      <div className="mb-8">
        <TableAction
          onSubmit={handleBulkAction}
          requesting={requesting}
        />
      </div>

      <hr className="mb-8 lg:mb-4" />

      {/* Controlled Table */}
      {/* TODO: optimize UI for mobile */}
      <SystemProvider>
        <div className="mb-12">
          {
            tableData &&
            <ControlledTable
              data={tableData}
              columns={tableColumns}
              withCheckbox
              handleCheckbox={handleCheckbox}

              loading={requesting}
              pageCount={pageCount}
              onPageChange={handlePageChange}
              initialPageIndex={pageIndex}
            />
          }
        </div>
      </SystemProvider>
    </ArrayChecker>
  </>
}

export { PageContent }

/**
 * Helpers
 */
function matchDataToTable(data, language){
  let result = []

  if(data && data.length > 0){
    for (let index = 0; index < data.length; index++) {
      const {
        id,
        title,
        type,
        category,
        submission,
        date_short,
        cities,
        status,
        status_id,
      } = data[index];

      result.push({
        id,
        title: title?.[language.name],
        type,
        category: category?.[language.name],
        visibility: '',
        submission,
        cities,
        date_short,
        status: status/* ?.[language.name] */,
        status_id
      })
    }
  }

  return result
}

function generateLink(type, id){
  return (
    type === 'view' ? `/event/${id}/detail`
    : type === 'edit' ? `/dashboard/events/update/${id}`
    : `/dashboard/events`
  )
}
